// Action Types
import { MAP_TYPE, FETCH_FEEDBACK_CATEGORIES, SEND_FEEDBACK } from './actionTypes';

// Constants
import { MAP } from './constants';


const initialState = {
  mapTypeId: MAP.TYPE_ID.ROADMAP,
  feedbackCategories: null,
  feedback: {}
};

export default function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case MAP_TYPE.update(): {
      return { ...state, mapTypeId: action.payload };
    }

    case FETCH_FEEDBACK_CATEGORIES.request(): {
      return { ...state, feedbackCategories: null };
    }

    case FETCH_FEEDBACK_CATEGORIES.success(): {
      return { ...state, feedbackCategories: action.payload };
    }

    case FETCH_FEEDBACK_CATEGORIES.error(): {
      return { ...state, error: action.payload };
    }

    case SEND_FEEDBACK.request(): {
      return { ...state, feedback: { isSending: true } };
    }

    case SEND_FEEDBACK.success(): {
      return { ...state, feedback: { wasSent: true } };
    }

    case SEND_FEEDBACK.error(): {
      return { ...state, error: action.payload, feedback: {} };
    }

    default:
      return state;
  }
}
